export const getFullNameInitials = (name: string, lastName: string): string => {
  if (!name && !lastName) return "";

  const nameInitial = name ? name.charAt(0).toLocaleUpperCase() : "";
  const lastNameInitial = lastName
    ? lastName.charAt(0).toLocaleUpperCase()
    : "";

  return nameInitial + lastNameInitial;
};
